<div class="row justify-content-center">
    <div class="col-24">
        <div class="role-descriptions">
            <h3 class="role-descriptions-title">Beschrijving gebruikersrollen</h3>
            <div class="roles-legend">
                <span class="roles-legend-item">
                    <i class="fa-regular fa-calendar" aria-hidden="true"></i> Inplanbaar
                </span>
                <span class="roles-legend-item">
                    <i class="fa fa-store-slash" aria-hidden="true"></i> Externe gebruiker
                </span>
                <span class="roles-legend-item">
                    <i class="fa fa-lock" aria-hidden="true"></i> Aanvragen via Codalt
                </span>
            </div>

            <p class="role-descriptions-intro">
                Een gebruiker kan meerdere rollen hebben. De meest uitgebreide rechten zijn van toepassing.
            </p>

            <div class="roles-grid">
                @for (role of roles; track role) {
                    <div class="role-item">
                        <strong class="role-heading">
                            {{ role.name }}
                            @if (hasPlannableFunctionality(role)) {
                                <i class="fa-regular fa-calendar" aria-hidden="true"></i>
                            }
                            @if (role.is_external) {
                                <i class="fa fa-store-slash" aria-hidden="true"></i>
                            }
                            @if (role.restricted) {
                                <i class="fa fa-lock" aria-hidden="true"></i>
                            }
                        </strong>
                        <div class="role-content">{{ role.description }}</div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
